const translations = {
  "en": {
    "Exceeds the maximum number of assets allowed in the portfolio (Max 50)": "Exceeds the maximum number of assets allowed in the portfolio (Max 50)"
  },
  "zh-tw": {
    "Exceeds the maximum number of assets allowed in the portfolio (Max 50)": "你的投資組合資產已達 50 個上限。"
  }
};

export default translations;
